import { EntityModel } from '@/interfaces'
import {
  ALL_FIELD_VISIBILITY_CONFIGS_QUERY,
  CREATE_FIELD_VISIBILITY_CONFIG_MUTATION,
  DELETE_FIELD_VISIBILITY_CONFIG_MUTATION,
  FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION,
  SINGLE_FIELD_VISIBILITY_CONFIG_QUERY,
  UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION,
} from './graphql'
import ratioTravelEntity from '@/entities/ratioTravel/entity'

const customBookingFormFieldVisibilityConfigModel: EntityModel = {
  name: 'fieldVisibilityConfig',
  namePlural: 'fieldVisibilityConfigs',
  uniqueName: 'customBookingFormFieldVisibilityConfig',
  uniqueNamePlural: 'customBookingFormFieldVisibilityConfigs',
  path: 'travel/booking/custom_data/field_visibility_config',
  baseUrl: '/travel/booking/custom_data/field_visibility_configs',
  translationPrefix: 'entities:customBookingFormFieldVisibilityConfig.',
  getDisplayName: (values: any) => {
    return 'FIELD VISIBILITY CONFIG'
  },
  gql: {
    getAll: ALL_FIELD_VISIBILITY_CONFIGS_QUERY,
    getSingle: SINGLE_FIELD_VISIBILITY_CONFIG_QUERY,
    create: CREATE_FIELD_VISIBILITY_CONFIG_MUTATION,
    update: UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION,
    delete: DELETE_FIELD_VISIBILITY_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION,
  },
  attributes: {
    pricingTravels: {
      name: 'pricingTravels',
      label: 'entities:customBookingFormFieldVisibilityConfig.attributes.pricingTravels.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioTravelEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default customBookingFormFieldVisibilityConfigModel
